module.exports = __webpack_public_path__ + "images/light-final-bg2.jpg";